export const MOMENT_DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const TEXT_MASK_DATE_FORMAT = 'mm/dd/yyyy';
export const FIRST_PRICING_FORMAT = 'MMM DD YYYY hh:mmA';
export const SHORT_DATE_FORMAT = 'MM/dd/yyyy';
export const LONG_DATE_FORMAT = `${MOMENT_DEFAULT_DATE_FORMAT} HH:mm:ss`;

export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const MDY_FORMAT = 'MM-DD-YYYY';
export const MOMENT_SUPPORTED_DATE_FORMATS = [MDY_FORMAT, ISO_DATE_FORMAT, MOMENT_DEFAULT_DATE_FORMAT];
export const MOMENT_SUPPORTED_DATE_TIME_FORMATS = [
  'MM-DD-YYYY HH:mm:ss',
  'YYYY-MM-DD HH:mm:ss',
  'MM/DD/YYYY HH:mm:ss',
  'MM-DD-YYYY hh:mm A',
  'YYYY-MM-DD hh:mm A',
  'MM/DD/YYYY hh:mm A',
];
